import { REDIRECT_TO_FAVORITE } from 'conf/constants';

export const setRedirectToFavorite = value => {
  return { type: REDIRECT_TO_FAVORITE, payload: value };
};